module.exports = __webpack_public_path__ + "static/media/resultsImage.428c8a3b.jpg";